module.exports = __webpack_public_path__ + "static/media/logo-american-express-256.521cedcb.png";